import { action, computed, makeObservable, observable } from 'mobx';

const storage = localStorage;
const MEMBER_ID = 'memberId';
const BIRTHDAY = 'birthday';

export class Auth {
  @observable memberId = storage.getItem(MEMBER_ID) || '';
  @observable birthday = storage.getItem(BIRTHDAY) || '';

  constructor() {
    makeObservable(this);
  }

  @action
  setInfo = (memberId: string, birthday: string) => {
    try {
      storage.setItem(MEMBER_ID, memberId);
      storage.setItem(BIRTHDAY, birthday);
    } finally {
      this.memberId = memberId;
      this.birthday = birthday;
    }
  };

  @action
  clearInfo = () => {
    try {
      storage.removeItem(MEMBER_ID);
      storage.removeItem(BIRTHDAY);
    } finally {
      this.memberId = '';
      this.birthday = '';
    }
  };

  @action
  signOut = () => {
    this.clearInfo();
  };

  @computed
  get loggedIn(): boolean {
    return !!this.memberId && !!this.birthday;
  }

  @computed
  get memberLoginReq() {
    return {
      memberId: this.memberId,
      birthday: this.birthday
    };
  }
}

export default new Auth();
